import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/CSS/global.css'
/* import axios from 'axios' */
import axios from './middlewares/axios.interceptors'
import './assets/Iconfont/iconfont.css'
import VueCurrencyInput from 'vue-currency-input'

Vue.prototype.$http = axios
Vue.prototype.convertDecimal= function(number){
  if(!isNaN(number)){
     return +((Math.round(number*100)/100).toFixed(2))
  }else{
    return number;
  }
}
Vue.prototype.convertThousandth= function(originVal){
  if (typeof (originVal) === 'number') {
     
     return (Math.round(originVal * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
}
Vue.use(VueCurrencyInput)
/* axios.defaults.baseURL = 'https://localhost:44343' */
/* axios.interceptors.request.use(config => {
  return config
})
axios.interceptors.response.use(config => {
  console.log("response")
  console.log(config)
  return config
}) */

Vue.filter("dateFormat",function(originVal)
{
  if(!!originVal)
  {
   const dt = new Date(originVal)
   const y = dt.getFullYear()
   const m = (dt.getMonth() + 1 + '').padStart(2,'0')
   const d = (dt.getDate() + '').padStart(2,'0')
   const hh = (dt.getHours() + '').padStart(2,'0')
   const mm = (dt.getMinutes() + '').padStart(2,'0')
   const ss = (dt.getSeconds() + '').padStart(2,'0')
   return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  } 
})

Vue.filter("thousandth",function(originVal)
{
  if (typeof (originVal) === 'number') {
     return (Math.round(originVal * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
})





Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
